import React from "react";
import { Breadcrumbs, Chip } from '@mui/material';
import { withStyles } from "@mui/styles";
import HomeIcon from '@mui/icons-material/Home';
import BackButton from "./BackButton";

const StyledBreadcrumb = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[100],
    height: theme.spacing(3),
    color: theme.palette.grey[800],
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: theme.palette.grey[300],
    },
    "&:active": {
      boxShadow: theme.shadows[1],
    },
  },
}))(Chip);

const UrlBreadcrumb = ({ history, links = [], ...props }) => {
  return (
    <Breadcrumbs>
      {[
        { label: "Inicio", icon: <HomeIcon fontSize="small" />, to: "/" },
        ...links,
      ].map((link, index) => {
        return (
          <StyledBreadcrumb
            style={{display: "flex", alignItems: "center", padding: "0 8px"}}
            key={index}
            label={link.label}
            icon={link.icon}
            onClick={() => {
              history.push(link.to ? link.to : "#");
            }}
          />
        );
      })}
    </Breadcrumbs>
  );
};

export default UrlBreadcrumb;
